// extracted by mini-css-extract-plugin
module.exports = {"backLink":"BackLink_backLink__ZMQRD","backArrow":"BackLink_backArrow__M5aKN"};